export const SERIES_FETCH = 'Series/FETCH';
export const SERIES_FETCH_SUCCESS = 'Series/FETCH_SUCCESS';
export const SERIES_FETCH_ERROR = 'Series/FETCH_ERROR';
export const SERIES_ADD = 'Series/ADD';
export const SERIES_ADD_SUCCESS = 'Series/ADD_SUCCESS';
export const SERIES_UPDATE = 'Series/UPDATE';
export const SERIES_UPDATE_SUCCESS = 'Series/UPDATE_SUCCESS';
export const SERIES_DELETE = 'Series/DELETE';
export const SERIES_DELETE_SUCCESS = 'Series/DELETE_SUCCESS';
